import React from "react";
import ReactDOM from "react-dom";
import {Reports} from "../components/Reports";

export const insertReports = () => {
  const apps = document.querySelectorAll('[data-fqxi-type="reports"]');

  if (apps.length === 0) {
    return;
  }

  apps.forEach((element) => {
    ReactDOM.render(<Reports />, element);
  });
};
